// 追梦中国相关页面
export var ROUTE_NAME = {
  GAME_RANK: 'GAME_RANK'
};
export function getGameImg(name) {
  return require("@/assets/images/game/" + name);
}